import { Progress } from '@/components/ui/progress';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

interface UserDeleteProgressProps {
  current: number;
  total: number;
  currentTable: string;
  results: Array<{ table: string; success: boolean; message: string }>;
}

export function UserDeleteProgress({
  current,
  total,
  currentTable,
  results,
}: UserDeleteProgressProps) {
  const percentage = total > 0 ? (current / total) * 100 : 0;

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">
            Deleting from {current} of {total} table(s)
          </span>
          <span className="font-medium">{Math.round(percentage)}%</span>
        </div>
        <Progress value={percentage} className="h-2" />
        {currentTable && (
          <div className="flex items-center gap-2 text-sm">
            <Loader2 className="h-4 w-4 animate-spin" />
            <span>Currently processing: {currentTable}</span>
          </div>
        )}
      </div>

      <div className="space-y-2 max-h-64 overflow-y-auto">
        {results.map((result, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-2 rounded-md bg-muted/50"
          >
            <span className="text-sm capitalize">{result.table.replace(/_/g, ' ')}</span>
            <div className="flex items-center gap-2">
              {result.success ? (
                <>
                  <CheckCircle2 className="h-4 w-4 text-green-600" />
                  <span className="text-xs text-muted-foreground">Success</span>
                </>
              ) : (
                <>
                  <XCircle className="h-4 w-4 text-destructive" />
                  <span className="text-xs text-destructive">{result.message}</span>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
